export const PRIMARY_THEME = "#EA7043";
export const SECONDARY_THEME = "#BA5E3C";
export const GREY_THEME = "#868B90";
export const BORDER_COLOR = "rgba(8, 10, 12, 0.175)";
export const BorderRadius = "0.3rem";
